var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#112154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112 113.34v-113.34h-96v128h81.336zm-14.238 10.277v-9.8555h9.8555zm-78.961-120.81h90.398v108.16h-14.242v14.242h-76.156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.793 81.129-3.8086-3.7031-2.5117 2.7227 6.6133 6.4297 11.555-14.039-2.7891-2.4219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.793 102.55-3.8086-3.7031-2.5117 2.7227 6.6133 6.4336 11.555-14.039-2.7891-2.4219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.754 73.441h41.773v2.8008h-41.773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.754 80.457h41.773v2.8008h-41.773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.754 94.859h41.773v2.8008h-41.773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.754 101.88h41.773v2.8008h-41.773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.992 47.91h2.8008v6.4336h-2.8008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.637 32.969h2.8008v21.379h-2.8008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.281 22.105h2.8008v32.238h-2.8008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.93 32.289h2.8008v22.059h-2.8008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.574 42.672h2.8008v11.676h-2.8008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.258 55.145c9.3047 0 16.875-7.5703 16.875-16.875 0-9.3047-7.5703-16.871-16.875-16.871-9.3008 0-16.871 7.5664-16.871 16.871-0.003907 9.3047 7.5664 16.875 16.871 16.875zm0-30.941c7.7617 0 14.07 6.3125 14.07 14.07 0 7.7617-6.3125 14.07-14.07 14.07-7.7578 0-14.07-6.3125-14.07-14.07 0-7.7578 6.3086-14.07 14.07-14.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.883 36.871h-10.227v-10.219h-2.8008v13.02h13.027z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3_표통.52a09d2dfe40369d4c97eab38f7e855e.svg";
export { ForwardRef as ReactComponent };